import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Mail, MapPin, MessageCircle, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative mt-32 tl-dark" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <img
              src="/assets/logo.png"
              alt="BrandChilly"
              className="h-48 md:h-56 w-auto mb-2 -ml-4"
            />
            <p className="text-zinc-400 text-sm leading-relaxed max-w-md font-body">
              The personal branding and business growth agency turning founders
              into category-defining creators on Instagram, YouTube and the
              internet. Heat-tested frameworks. Real audience. Real authority.
            </p>
            <Link
              to="/book"
              className="btn-primary mt-7 text-sm"
              data-testid="footer-book-call-btn"
            >
              Book a discovery call <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Navigate</div>
            <ul className="space-y-3 text-zinc-400">
              <li><Link to="/" className="hover:text-white transition">Home</Link></li>
              <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
              <li><Link to="/services" className="hover:text-white transition">Services</Link></li>
              <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow mb-5">Reach Us</div>
            <ul className="space-y-3 text-zinc-400 text-sm">
              <li className="flex items-center gap-3">
                <Mail size={15} className="text-red-500" />
                <a href="mailto:brandchilly@gmail.com" className="hover:text-white transition">brandchilly@gmail.com</a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={15} className="text-[#25D366]" />
                <a href="https://wa.me/919811960890?text=Hi%20BrandChilly!%20I%27d%20like%20to%20know%20more." target="_blank" rel="noopener noreferrer" className="hover:text-white transition" data-testid="footer-whatsapp">Chat on WhatsApp</a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={15} className="text-red-500" />
                <span>India · Worldwide remote</span>
              </li>
              <li className="flex items-center gap-4 pt-2">
                <a href="https://instagram.com/brandchilly" target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-white transition" data-testid="footer-instagram">
                  <Instagram size={18} />
                </a>
                <a href="https://youtube.com/@brandchilly" target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-white transition" data-testid="footer-youtube">
                  <Youtube size={18} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider-line mt-16 mb-6" />
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-xs text-zinc-500 font-body">
          <p>© {new Date().getFullYear()} BrandChilly. All rights reserved.</p>
          <p className="tracking-wider uppercase">Built with heat · 30·30·40 Framework™</p>
        </div>
      </div>
    </footer>
  );
}
